import { render, staticRenderFns } from "./InsertScreen.vue?vue&type=template&id=0f2edbb6"
import script from "./InsertScreen.vue?vue&type=script&lang=js"
export * from "./InsertScreen.vue?vue&type=script&lang=js"
import style0 from "./InsertScreen.vue?vue&type=style&index=0&id=0f2edbb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports